// extracted by mini-css-extract-plugin
export default {"coverUploadModal":"cover-upload-modal_coverUploadModal__-28kA","uploadZone":"cover-upload-modal_uploadZone__9gPlY"};